<section>
  <get-in-touch></get-in-touch>
  <get-in-touch-details></get-in-touch-details>
</section>